/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './truncate-text-popover.component';
export * from './truncate-text-popover.module';
export * from './truncate.pipe';
